<template>
  <div style="display: grid" class="home-container">
    <div>
      <nav
        class="
          navbar navbar-transparent navbar-color-on-scroll
          fixed-top
          navbar-expand-lg
        "
        color-on-scroll="100"
        id="sectionsNav"
      >
        <div class="container-fluid">
          <div class="navbar-translate">
            <router-link to="/">
              <img
                src="../../../public/assets/img/logo.png"
                class="img-fluid ml-sm-4 cursor-pointer"
                style="width: 70px"
                alt
              />
            </router-link>
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="sr-only">Toggle navigation</span>
              <span class="navbar-toggler-icon" />
              <span class="navbar-toggler-icon" />
              <span class="navbar-toggler-icon" />
            </button>
          </div>

          <div class="collapse navbar-collapse">
            <ul class="navbar-nav pt-2 ml-auto">
              <li class="p-2">
                <router-link class="nav-link" to="/about"
                  >About</router-link
                >
              </li>

              <li class="p-2">
                <router-link class="nav-link" to="/#"
                  >Alumni</router-link
                >
              </li>
              <li class="p-2">
                <router-link class="nav-link" to="/modules"
                  >Modules</router-link
                >
              </li>
              <li class="p-2">
                <router-link class="nav-link" to="/dashboard"
                  >Student’s portal</router-link
                >
              </li>
            </ul>
            <ul class="navbar-nav pt-2"
               v-if="!$store.getters.loggedIn">
              <li class="p-2">
                <router-link class="nav-link btn btn-orange pl-3 pr-3" to="/registration" style="border-radius: 15px; font-size:20px"
                  >Apply</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
    <div class="d-flex justify-content-center" id="contentItem">
      <div
        class="
          container-fluid
          custom-container-fluid
          ml-md-5
          home_item
          text-light
        "
      >
        <div class="row">
          <div class="col-md-12">
            <h1 class="header-title" style="font-size: 61px; font-weight: 900">
              Interested in becoming a <br />
              Certified <span class="text-green">Startup Coach? </span>
            </h1>
          </div>
          <div class="col-md-5">
            <p class="mb-5">
              Join our Startup Coach School and become a Certified Startup
              Coach. We provide you with standardized modern training and
              certification to enable you to become a professional in the
              startup coaching industry.
            </p>
            <p>Applications are open now.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="row">
              <div class="col-6">
                <button
                  class="
                    btn btn-outline-orange btn-block
                    custom-button
                    text-light
                  "
                >
                  Learn More
                </button>
              </div>
              <div class="col-6">
                  <router-link to="/registration"
                    class="btn btn-orange btn-block custom-button"
                  >
                    Apply
                  </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import Swal from "sweetalert2";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

export default {
  name: "Talent",
  data() {
    return {
      isLoading: false,
      fullPage: true,
      height: 128,
      width: 128,
      list: [],
      talents: [],
      filter_all: "all",
      categorised_talents: [],
    };
  },
  components: {
    TalentNavbar: () => import("@/components/TransparentNavbar"),
    Loading: () => import("vue-loading-overlay"),
    bottomFooter: () => import("@/components/Footer"),
  },
  methods: {
    getTalents() {
      return new Promise((resolve, reject) => {
        this.isLoading = true;
        axios
          .get(`${process.env.VUE_APP_JOB_FAIR_RESEARCH_URL}/getTalents`)
          .then((res) => {
            let data = res.data.data;
            let filtered_data = data.filter((e) => {
              return e["is_available"] === true;
            });
            this.talents = filtered_data;
            this.list = filtered_data;
            $(".st0").addClass("active");
            resolve("done");
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
  },

  mounted() {
    document.title = "Home || Start Up Coach School";
  },
  destroyed() {
  },
};
</script>

<style src="../../../public/assets/css/general-front-css.css" scoped />

<style scoped>
/* home styling */
.home-container {
  height: 100vh;

  background: radial-gradient(
      33.5% 33.5% at 9.2% 9.67%,
      rgba(231, 247, 253, 0.4) 1.78%,
      rgba(0, 0, 0, 0) 100%
    ),
    linear-gradient(79.4deg, #021d1f 27.5%, rgba(2, 29, 31, 0.2) 92.73%),
    url("../../assets/home_bg.png");
  background-size: cover;
}

.navbar {
  box-shadow: none !important;
}

.custom-button {
  padding: 1rem 0px;
  border-radius: 15px;
  font-size: 25px;
}

@media screen and (max-width: 567px) {
  .header-title {
    font-size: 30px !important;
  }
  .navbar.navbar-transparent{
    padding-left:0 !important;
    padding-right:0 !important;
  }
}

#contentItem {
  position: relative;
  left: 50%;
  top: 35%;
  transform: translate(-50%, -50%);
}

.navbar {
  border: 0;
  border-radius: 3px;
  padding: 0.625rem 0;
  margin-bottom: 20px;
  color: #0599a9;
  background-color: #fff !important;
  box-shadow: 0 4px 18px 0px rgba(0, 0, 0, 0.12),
    0 7px 10px -5px rgba(0, 0, 0, 0.15);
  font-family: gotham;
}
.nav-link {
  color: white !important;
  font-size:16px
}

.nav .nav-item {
  position: relative;
}

.navbar.navbar-transparent {
  /*border-bottom: 1px solid var(--grey);*/
  background: transparent !important;
  /*height: 15%;*/
  padding-top: 2.5rem;
  padding-left:6rem;
  padding-right:4rem;
}

.nav-item a {
  color: black !important;
  font-family: var(--gotham);
  font-size: 17px !important;
  text-transform: none !important;
}

.navbar {
  box-shadow: none;
}

.dropdown-menu .dropdown-item:focus,
.dropdown-menu a:hover {
  color: white !important;
}
</style>
